import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginLayout from './Layout/LoginLayout';
import Login from './Page/login';
import List from './Page/List'
import Dashboard from './Page/Dashboard'
import AddCompany from './Page/Company/AddCompany';
import EditCompany from './Page/Company/EditCompany';
import { getToken } from './utils'
import { useSelector } from 'react-redux';

function App() {

  const [hasToken, setHasToken] = useState(false)
  const { loginStatus } = useSelector((state) => state.Login)


  console.log(hasToken);

  useEffect(() => {
    if (localStorage.getItem('access_token') != null) {
      setHasToken(true)
    }
    else {
      setHasToken(false)
    }
  }, [loginStatus])


  return (
    <div className="App">
      <Routes>
        {!hasToken ?
          <Route path="/*" element={<Login />} />
          :
          <Route path='/dashboard' element={<Dashboard />}>
            <Route index element={<List />} />
            <Route path='AddCompany' element={<AddCompany />} />
            <Route path="EditCompany/:id" element={<EditCompany />} />
          </Route>
        }
      </Routes>
    </div>
  );
}

export default App;
